import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Utils} from '@astek/utils';
import {HealthCenterRestApiService} from '../http/health-center-rest-api.service';
import {ApiHealthCenterResponse} from '../http/api-health-center-response';

@Injectable()
export class HealthCenterResolver {

  constructor(
    private readonly _healthCenterRestApiService: HealthCenterRestApiService,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<ApiHealthCenterResponse> {
    if (Utils.isNullOrUndefined(route.params['healthCenterId'])) {
      throw new Error('Missing HealthCenter id');
    }

    return this._healthCenterRestApiService.requestHealthCenter(route.params['healthCenterId'] as string);
  }

}
